import { io, Socket } from 'socket.io-client';

// "undefined" means the URL will be computed from the `window.location` object
const URL = process.env.REACT_APP_SOCKETS_BASE_URL + '/events';

// export const socket = io(URL, {autoConnect: false, path: '/socket.io/', transports: ["websocket"]});
export function createSocket(): Socket {
    return io(URL, {autoConnect: false, path: '/socket.io/', transports: ["websocket"]});
}